var render = function render(){var _vm=this,_c=_vm._self._c;return _c('input',_vm._g({attrs:{"pattern":_vm.pattern,"placeholder":"$0.00","type":"text"},domProps:{"value":_vm.formattedValue},on:{"blur":_vm.handleBlur,"input":_vm.handleInput,"invalid":_vm.handleInvalid}},_vm.listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }